
<div class="table-responsive w-auto" style="background-color: white; padding-top: 20px; border-radius: 15px;">
  <div class="d-flex justify-content-end px-3 mb-2">
    <!-- <div style="background-color: #FAFAFA;padding: 10px; margin: 10px; cursor: pointer;border-radius: 10px; font-size: 16px; font-weight: 400; font-size: Sora;" (click)="downloadExcel()">
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.1707 3V7C14.1707 7.26522 14.276 7.51957 14.4635 7.70711C14.6511 7.89464 14.9054 8 15.1707 8H19.1707" stroke="#A0AEC0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.1707 21H7.17065C6.64022 21 6.13151 20.7893 5.75644 20.4142C5.38137 20.0391 5.17065 19.5304 5.17065 19V5C5.17065 4.46957 5.38137 3.96086 5.75644 3.58579C6.13151 3.21071 6.64022 3 7.17065 3H14.1707L19.1707 8V19C19.1707 19.5304 18.9599 20.0391 18.5849 20.4142C18.2098 20.7893 17.7011 21 17.1707 21Z" stroke="#A0AEC0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.1707 11V17" stroke="#A0AEC0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.17065 14L12.1707 17L15.1707 14" stroke="#A0AEC0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
         Download
    </div> -->
  </div>
  <table #exportTable class="table table-hover  custom-hover  text-center align-middle" style="background-color: white;">
    <thead class="table-light" style="background-color: white; padding-left: 10px;">
      <tr style="background-color: white;">
        <th *ngFor="let col of columns" (click)="col.sortable && onSort(col.field)" style="cursor: pointer;background-color: white;border-bottom: 0; border-top:1px solid #EEEFF2;font-size:14px; color: #718096;font-weight: 400;font-family:poppins;text-align: left;padding-left:30px">
          {{ col.headerName }}
          <ng-container *ngIf="col.sortable">
            <i *ngIf="sortField === col.field" class="ms-1"
               [ngClass]="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
            <i *ngIf="sortField !== col.field" class="ms-1 bi bi-arrow-down-up"></i>
          </ng-container>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data" (click)="onRowClick?.(row)" style=" border-top:1px solid #EEEFF2;text-align: left; padding-left:30px;cursor: pointer;">
        <td *ngFor="let col of columns" style="padding-left:30px" (click)="$event.stopPropagation()">
          <ng-container *ngIf="col.renderCell; else defaultCell">
            <div [innerHTML]="col.renderCell(row)"></div>
          </ng-container>
          <ng-template #defaultCell>{{ row[col.field] }}</ng-template>
        </td>
      </tr>

    </tbody>
  </table>
  <!-- Page Limit Selector -->
  <div class="d-flex justify-content-between align-items-center my-3 px-3">
    <div class="ms-3">
      <label style="font-family: Poppins; font-size: 14px; color: #718096;">
        Show result:
        <select
        class="form-select d-inline-block w-auto ms-2"
        [(ngModel)]="pageLimit"
        (change)="onPageLimitChange($event)"
        style="font-weight: 500;"
      >
        <option *ngFor="let option of [5, 10, 20, 50]" [value]="option">{{ option }}</option>
      </select>
      </label>
    </div>

    <!-- Pagination -->
    <nav>
      <ul class="pagination custom-pagination mb-0">
        <li class="page-item" [class.disabled]="page === 1">
          <button class="page-link" (click)="onPageChange(page - 1)"><svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3824 5.00073L8.38239 10.0007L13.3824 15.0007" stroke="#A0AEC0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </button>
        </li>

        <li class="page-item" *ngFor="let p of paginationArray()" [class.active]="p === page" [class.ellipsis]="p === '...'">
          <button class="page-link" (click)="onPageChange(p)" *ngIf="p !== '...'">{{ p }}</button>
          <span class="page-link" *ngIf="p === '...'">...</span>
        </li>

        <li class="page-item" [class.disabled]="page >= totalPages()">
          <button class="page-link" (click)="onPageChange(page + 1)"><svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.38232 5.00073L13.3823 10.0007L8.38232 15.0007" stroke="#A0AEC0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </button>
        </li>
      </ul>
    </nav>

  </div>
</div>

<!-- Pagination -->
